import {
    GET_LIST_CONFIRM_MONETIZATION,
    GET_START_LIST_MONETIZATION,
    GET_EMAIL_SEND_MONETIZATION,
    GET_LOADING_MONETIZATIONS,
    GET_LIST_MONETIZATIONS,
    GET_LIST_REPORTS,
} from "@/views/reports/store/types/types.js";
const getters = {
    [GET_LIST_CONFIRM_MONETIZATION]:  state => state.sendListConfirmMonetization,
    [GET_START_LIST_MONETIZATION]: state => state.listStartMonetization,
    [GET_LIST_MONETIZATIONS]: state => state.monetizationList,
    [GET_EMAIL_SEND_MONETIZATION]: state => state.emailSend,
    [GET_LOADING_MONETIZATIONS]: state => state.loading,
    [GET_LIST_REPORTS]: state => state.reports,
};

export default getters;